/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupcancel1Inputs */

const en_signupcancel1 = /** @type {(inputs: Signupcancel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel sign-up`)
};

const de_signupcancel1 = /** @type {(inputs: Signupcancel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

/**
* | output |
* | --- |
* | "Cancel sign-up" |
*
* @param {Signupcancel1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupcancel1 = /** @type {((inputs?: Signupcancel1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupcancel1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupcancel1(inputs)
	return de_signupcancel1(inputs)
});
export { signupcancel1 as "signupCancel" }